<!--
  - Copyright (c) 2008-2022 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->
<template>
  <div :class="['d-flex', 'align-items-center', addClass]">
    <div v-if="!lblAfter">
      <label class="mr-2" :for="id"><span v-html="lbl"></span></label>
    </div>
    <toggle-button
      :id="id"
      :value="value"
      :sync="true"
      @input="$emit('input', $event)"
      :disabled="disabled"
      :class="btnClass"
    ></toggle-button>
    <div v-if="lblAfter">
      <label :class="['ml-2', lblClass]" :for="id"><span v-html="lbl"></span></label>
      <tooltip-icon v-if="tooltip && tooltipNextToLabel" :text="tooltip" :html="true" class="ml-1"></tooltip-icon>
    </div>
    <div v-if="tooltip && !tooltipNextToLabel" class="ml-auto">
      <tooltip-icon :text="tooltip" :html="true"></tooltip-icon>
    </div>
  </div>
</template>

<script>
import TooltipIcon from "@/components/cockpit/TooltipIcon"

export default {
  name: "BasicLabelToggle",

  components: {
    TooltipIcon,
  },

  props: {
    id: { type: String, default: "toggle" },
    addClass: { default: "mt-3" },
    btnClass: { default: "" },
    lblClass: { default: "" },
    lbl: { type: String, default: "" },
    lblAfter: { type: Boolean, default: true },
    tooltip: { type: String, default: "" },
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    tooltipNextToLabel: { type: Boolean, default: false },
  },
}
</script>
